import { useMemo } from 'react';
import { useTravelAlertSubscriptionV1Query } from './TravelAlert.graphql.generated';
import type { ExistingSubscription, RawTravelAlertSubscription, TravelAlertTriggerType } from './PriceAlertModal.types';

type UseTravelAlertSubscriptionStatusParams = Readonly<{
  eventId: string | undefined;
  anonymousId: string | undefined;
  skip?: boolean;
}>;

export const useTravelAlertSubscriptionStatus = ({ eventId, anonymousId, skip = false }: UseTravelAlertSubscriptionStatusParams) => {
  const { data, loading } = useTravelAlertSubscriptionV1Query({
    variables: { input: { eventId: eventId!, anonymousId: anonymousId || undefined } },
    skip: skip || !eventId,
    batchMode: 'fast',
    fetchPolicy: 'cache-and-network',
  });

  const sub = data?.travelAlertSubscriptionV1;

  const existingSubscription: ExistingSubscription | undefined = useMemo(() => {
    if (!sub?.isVerifiedSubscription || sub.status !== 'ACTIVE') return undefined;
    return {
      id: sub.id,
      phoneNumber: sub.phoneNumber,
      email: sub.email,
      subscribedAlertTypes: sub.subscribedAlertTypes as unknown as ReadonlyArray<TravelAlertTriggerType>,
    };
  }, [sub]);

  const rawSubscription: RawTravelAlertSubscription | undefined = useMemo(() => {
    if (!sub) return undefined;
    return { id: sub.id, eventId: sub.eventId, status: sub.status };
  }, [sub]);

  return { existingSubscription, rawSubscription, loading };
};
